import React from 'react';
import { motion } from 'framer-motion';

export function RadioButton({ 
    id,
    name,
    value, 
    checked, 
    onChange, 
    label,
    description,
    disabled = false,
    className = '' 
}) {
    return (
        <label 
            htmlFor={id} 
            className={`
                flex items-start gap-3 p-3 rounded-lg border transition-colors cursor-pointer
                ${checked ? 'bg-[var(--bg-subtle)] border-[var(--accent)]' : 'bg-[var(--bg-surface)] border-[var(--border)] hover:border-[var(--border-strong)]'}
                ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
                ${className}
            `}
        >
            <div className="relative flex items-center justify-center mt-0.5">
                <input
                    type="radio"
                    id={id}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    className="sr-only" // Hidden for accessibility
                />
                <div className={`
                    w-4 h-4 rounded-full border transition-colors
                    ${checked ? 'border-[var(--accent)]' : 'border-[var(--border-strong)]'}
                `} />
                {checked && (
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                        className="absolute w-2 h-2 rounded-full bg-[var(--accent)]"
                    />
                )}
            </div>
            
            <div className="flex flex-col">
                <span className={`text-sm font-medium ${checked ? 'text-[var(--text-primary)]' : 'text-[var(--text-secondary)]'}`}>
                    {label}
                </span>
                {description && (
                    <span className="text-xs text-[var(--text-tertiary)] mt-0.5">
                        {description}
                    </span>
                )}
            </div>
        </label>
    );
}
